import { render, staticRenderFns } from "./BusinessSection.vue?vue&type=template&id=509059b4&scoped=true"
import script from "./BusinessSection.vue?vue&type=script&lang=js"
export * from "./BusinessSection.vue?vue&type=script&lang=js"
import style0 from "./BusinessSection.vue?vue&type=style&index=0&id=509059b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509059b4",
  null
  
)

export default component.exports